import { action } from 'typesafe-actions';
import { DocActionTypes } from './types';
import { DocAccessType, IDocuments, IFollowUpDocuments } from '../../../types';

export function approveDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  docStatus?: string,
  docPrevStatus?: string,
) {
  return action(DocActionTypes.APPROVE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason: '',
    status: docStatus === 'APPROVED' && docPrevStatus ? docPrevStatus : 'APPROVED',
  });
}

export function toggleDocStatusSuccess({
  followUpDocs,
  beforeComplete,
  beforeRequired,
  afterComplete,
  afterRequired,
}: {
  followUpDocs: IFollowUpDocuments;
  beforeComplete: number;
  beforeRequired: number;
  afterComplete: number;
  afterRequired: number;
}) {
  return action(DocActionTypes.TOGGLE_DOC_SUCCESS, {
    followUpDocs,
    beforeComplete,
    beforeRequired,
    afterComplete,
    afterRequired,
  });
}

export function toggleDocStatusFailure(error: string) {
  return action(DocActionTypes.TOGGLE_DOC_FAILURE, {
    error,
  });
}

export function rejectDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: IDocuments['status'],
  reason?: string,
) {
  return action(DocActionTypes.REJECT_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status,
  });
}

export function rescindRejectDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: IDocuments['status'],
  reason?: string,
) {
  return action(DocActionTypes.RESCIND_REJECT_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status,
  });
}

export function deleteDoc(
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  reason?: string,
) {
  return action(DocActionTypes.DELETE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    reason,
    status: 'DELETED',
  });
}

export function requestCustomFollowUpDoc(
  documentName: string,
  documentDescription: string,
  followUpArea: string,
  userAccess?: DocAccessType,
) {
  return action(DocActionTypes.CUSTOM_DOCUMENT_REQUEST, {
    documentName,
    documentDescription,
    followUpArea,
    userAccess,
  });
}
